import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { QR_IMAGE_ACCEPT, qrImageError } from 'utils/functions/qrRequisite';
import styles from './QrImage.module.css';

interface IQrImageInputProps {
  title: string;
  file: File | null;
  onChange: (file: File | null, error?: string) => void;
  error?: string;
  currentUrl?: string | null;
  required?: boolean;
}

export const QrImageInput = ({ title, file, onChange, error, currentUrl, required }: IQrImageInputProps) => {
  const [fileUrl, setFileUrl] = useState<string>();

  useEffect(() => {
    if (!file) {
      setFileUrl(undefined);
      return;
    }
    const url = URL.createObjectURL(file);
    setFileUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const preview = fileUrl || currentUrl;

  return (
    <div className={styles.field}>
      <div className={styles.title}>
        {required && <span style={{ color: '#FE5B37' }}>*</span>}
        {title}
      </div>
      <div className={styles.row}>
        {preview ? (
          <img className={styles.preview} src={preview} alt={'QR-код'} />
        ) : (
          <div className={clsx(styles.preview, styles.empty)}>QR</div>
        )}
        <div className={styles.info}>
          <label className={styles.pick}>
            {preview ? 'Заменить изображение' : 'Выбрать изображение'}
            <input
              className={styles.input}
              type='file'
              accept={QR_IMAGE_ACCEPT}
              aria-label={'Изображение QR-кода'}
              onChange={(event) => {
                const picked = event.target.files?.[0];
                event.target.value = '';
                if (!picked) {
                  return;
                }
                const pickedError = qrImageError(picked);
                onChange(pickedError ? null : picked, pickedError);
              }}
            />
          </label>
          <span className={styles.hint}>{file ? file.name : 'PNG или JPG, до 5 МБ'}</span>
        </div>
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

// Image replacement inside the requisite edit form: the file goes to `newQrImage`, backend errors come as its error.
export const QrImageEditField = ({ currentUrl }: { currentUrl?: string | null }) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const [pickError, setPickError] = useState<string>();
  register('newQrImage');
  const file: File | null = watch('newQrImage') ?? null;

  return (
    <QrImageInput
      title={'QR-код'}
      file={file}
      currentUrl={currentUrl}
      error={pickError ?? (errors.newQrImage?.message as string | undefined)}
      onChange={(next, nextError) => {
        setPickError(nextError);
        setValue('newQrImage', next);
      }}
    />
  );
};
